import { AdTag } from "@fresh8/types/src";
import mapSportRadarData from "./lib/mapSportRadarData";
import properties from "./properties";
import { jsonp } from "./lib/jsonp";
import { BetData } from "@fresh8/types/src/betData";

function queryStringBuilder(dict: Partial<{ [name: string]: string }>) {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(dict)) {
    if (value) {
      params.append(key, value as string);
    }
  }

  return params.toString();
}

declare global {
  interface Window {
    adtagData?: AdTag;
    adtagId?: string;
  }
}

export async function getAdtag(
  id: string | null,
  useMockBrand?: string,
  ref?: string
): Promise<AdTag> {
  if (useMockBrand) {
    // return import("../mocks/mock-brand.json").then(data => ({ ...data }));
  }

  if (window.adtagData) {
    return window.adtagData;
  }

  const headers = new Headers({
    ["Accept"]: "application/json"
  });

  const response = await fetch(
    `http${properties.adtagCdnUri.indexOf("localhost") >= 0 ? "" : "s"}://${
      properties.adtagCdnUri
    }/json/${id}${ref ? `?ref=${ref}` : ""}`,
    {
      method: "GET",
      mode: "cors", // no-cors, *cors, same-origin
      cache: "default",
      headers
    }
  );

  return response.json();
}

export async function getBet(
  id?: string,
  ref?: string,
  clickUrl?: string,
  targetUrl?: string,
  useMockData?: string,
  rest?: { [x: string]: string | undefined }
): Promise<BetData> {
  id = window.adtagId || id;
  if (useMockData) {
    //   return import("../mocks/mock-multiple-nfl.json");
  }
  const headers = new Headers({
    ["Accept"]: "application/json"
  });

  const queryParams =
    typeof ref === "string" ||
    typeof clickUrl === "string" ||
    typeof targetUrl === "string" ||
    (rest && Object.keys(rest).length > 0)
      ? queryStringBuilder({
          ref,
          clickUrl,
          targetUrl,
          ...rest
        })
      : undefined;

  if (rest?.useSportradarDco) {
    const response = await jsonp(
      "https://dcp.ads.sportradar.com/dco?config=CnsiYW1vdW50T2ZFdmVudHMiOjMsImFmZmlsaWF0ZUlkIjoiMTAwMSIsInNwb3J0SWRzIjpbInNvY2NlciJdfQ==",
      { name: "jsonp_dco" }
    );
    const mappedData = mapSportRadarData(response);

    return new Promise(resolve => {
      return resolve(mappedData);
    });
  } else {
    const response = await fetch(
      `http${properties.dataApiUri.indexOf("localhost") >= 0 ? "" : "s"}://${
        properties.dataApiUri
      }/${id}/adtag.js?${queryParams ? queryParams : ""}`,
      {
        method: "GET",
        mode: "cors", // no-cors, *cors, same-origin
        cache: "default",
        headers
      }
    );
    return response.json();
  }
}

type publisherRes = {
  error: string;
  payload: BetData;
  catalogue_id: string;
  catalogueID: string;
  recommender_behaviour: string;
  recommender_detail: string;
};

export async function getPublisherBet(
  primaryBehaviour?: string,
  primaryProductSetId?: string,
  secondaryBehaviour?: string,
  secondaryProductSetId?: string,
  campaignBehaviour?: string,
  campaignProductSetId?: string,
  ref?: string,
  sport?: string,
  competitor?: string,
  competition?: string,
  operator?: string,
  useMockData?: string,
  primaryRecommender?: string,
  secondaryRecommender?: string,
  rest?: { [x: string]: string | undefined }
): Promise<publisherRes> {
  if (useMockData) {
    // const payload = ((await import(
    //   "../mocks/mock-single-h2h.json"
    // )) as unknown) as any;
    // return {
    //   payload: payload.default as BetData,
    //   error: "",
    //   catalogue_id: "",
    //   catalogueID: "",
    //   recommender_behaviour: ""
    // };
  }
  const headers = new Headers({
    ["Accept"]: "application/json"
  });

  const queryParams =
    typeof primaryBehaviour === "string" ||
    typeof primaryProductSetId === "string" ||
    typeof secondaryBehaviour === "string" ||
    typeof secondaryProductSetId === "string" ||
    typeof campaignBehaviour === "string" ||
    typeof campaignProductSetId === "string" ||
    typeof ref === "string" ||
    typeof sport === "string" ||
    typeof competitor === "string" ||
    typeof competition === "string" ||
    typeof operator === "string" ||
    typeof primaryRecommender === "string" ||
    typeof secondaryRecommender === "string" ||
    (rest && Object.keys(rest).length > 0)
      ? queryStringBuilder({
          primaryBehaviour,
          primaryProductSetId,
          secondaryBehaviour,
          secondaryProductSetId,
          campaignBehaviour,
          campaignProductSetId,
          ref,
          sport,
          competitor,
          competition,
          operator,
          primaryRecommender,
          secondaryRecommender
        })
      : undefined;

  if (rest?.useSportradarDco) {
    const response = await jsonp(
      "https://dcp.ads.sportradar.com/dco?config=CnsiYW1vdW50T2ZFdmVudHMiOjMsImFmZmlsaWF0ZUlkIjoiMTAwMSIsInNwb3J0SWRzIjpbInNvY2NlciJdfQ==",
      { name: "jsonp_dco" }
    );
    const mappedData = mapSportRadarData(response);

    return new Promise(resolve => {
      return resolve({
        payload: mappedData,
        catalogue_id: "",
        catalogueID: "",
        recommender_behaviour: "",
        recommender_detail: "",
        error: ""
      });
    });
  } else {
    const response = await fetch(
      `http${
        properties.dataPublisherApiUri.indexOf("localhost") >= 0 ? "" : "s"
      }://${properties.dataPublisherApiUri}/v1/publisher?${
        queryParams ? queryParams : ""
      }`,
      {
        method: "GET",
        mode: "cors", // no-cors, *cors, same-origin
        cache: "default",
        headers
      }
    );
    if (!response.ok) throw new Error(response.status.toString());
    return response.json();
  }
}

export async function getJSON<T>(url: string): Promise<T> {
  const headers = new Headers({
    ["Accept"]: "application/json"
  });

  const response = await fetch(url, {
    method: "GET",
    mode: "cors", // no-cors, *cors, same-origin
    cache: "default",
    headers
  });

  return response.json();
}

export async function getPreview(previewOptions: {
  operator: string | undefined;
  sport: string | undefined;
  eventId: string | undefined;
  competitors: string | undefined;
  competitions: string | undefined;
  marketIds: string | undefined;
  marketTypes: string | undefined;
  limit: string | undefined;
}): Promise<BetData> {
  const headers = new Headers({
    ["Accept"]: "application/json"
  });

  const queryParams = queryStringBuilder(previewOptions);

  const response = await fetch(
    `http${properties.previewApiUri.indexOf("localhost") >= 0 ? "" : "s"}://${
      properties.previewApiUri
    }?${queryParams}`,
    {
      method: "GET",
      mode: "cors", // no-cors, *cors, same-origin
      cache: "default",
      headers
    }
  );

  return response.json();
}
